import { CursorPaginatedResponseSchema, DefaultCursorPageSchema } from 'notable-common';
import { z } from 'zod';
import { FlowReferenceTableRowDataSchema } from './referenceTable.js';
export const FlowReferenceTableMetadataSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    organizationId: z
        .uuid()
        .nullable()
        .describe('The owning organization, or null for a global table shared by every organization.'),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    deleted: z.iso.datetime().nullable(),
});
export const FlowReferenceTablePageQuerySchema = z
    .object({
    q: z
        .string()
        .min(1)
        .max(200)
        .describe('Return only tables whose name contains this.')
        .optional(),
    // An empty array would serialize to no parameter at all, and so ask for every organization.
    organizationId: z
        .union([z.uuid(), z.array(z.uuid()).min(1)])
        .describe('Return only tables of this organization, or of any of these organizations.')
        .optional(),
    page: DefaultCursorPageSchema,
})
    .strict();
export const FlowReferenceTablePageResponseSchema = CursorPaginatedResponseSchema(FlowReferenceTableMetadataSchema);
export const FlowReferenceTableSummarySchema = z.object({
    referenceTable: FlowReferenceTableMetadataSchema,
    columnNames: z.array(z.string()),
    rowCount: z.number().int().nonnegative(),
});
export const FlowReferenceTableRowsQuerySchema = z
    .object({ page: DefaultCursorPageSchema })
    .strict();
export const FlowReferenceTableRowsResponseSchema = CursorPaginatedResponseSchema(FlowReferenceTableRowDataSchema);
//# sourceMappingURL=read.js.map